export default __webpack_public_path__ + "static/media/Panel_0_Stage1.73ed374e.svg";